export const LOCAL_CART_KEY = 'localCartData'
